import * as types from "../../actionTypes";

export const updatePersonalInfo = (data) => {
  return { type: types.UPDATE_PERSONAL_INFO_REQUEST, payload: data };
};

export const resetData = () => ({
  type: types.RESET_DATA,
});
